import React from 'react';
import PropTypes from 'prop-types';
import Button from '@nexus/fff-ui-shared/Button';

import styles from './NavigationButtons.module.scss';

const backButtonStyles = {
  border: '1px solid #000',
  background: '#fff',
};

const NavigationButtons = ({ onClickBack, onClickNext }) => (
  <div className={styles.wrapper}>
    <Button
      styles={backButtonStyles}
      variation="black-outline"
      onClick={onClickBack}
    >
      Back
    </Button>
    <Button onClick={onClickNext}>Next</Button>
  </div>
);

NavigationButtons.propTypes = {
  onClickBack: PropTypes.func.isRequired,
  onClickNext: PropTypes.func.isRequired,
};

export default NavigationButtons;
